module.exports = __webpack_public_path__ + "img/logoImg.1ab5832b.svg";